
import * as z from "zod";

export const formSchema = z.object({
  full_name: z.string().min(2, "Name must be at least 2 characters"),
  congregation_name: z.string().optional(),
  bible_version: z.string().default("KJV"),
});

export type WelcomeFormValues = z.infer<typeof formSchema>;
